import React, {useState} from "react";
import {
    Grid,
    TextField,
} from "@material-ui/core";

import axios from "axios";
import CustomModal from "../../../../Components/Modals/CustomModal";
import * as requestHeaders from "../../../../Constants/requestHeaders";
import * as lang from "../../../../Constants/strings";
import {bindActionCreators} from "redux";
import * as actionCreators from "../../../../actions/actions";
import {connect} from "react-redux";

const Cancel = (props) => {
    const {
        open,
        close,
        language,
        installationId,
        userId,
        refetch
    } = props;

    const [note, setNote] = useState("");

    const cancel = async () => {
        try {
            await axios.post("/api/cancel_installation", {
                id: installationId, userId: userId, note: note, geolocation: props.geolocation },{
                ...requestHeaders.getPostHeader(),
            });
            refetch();
            close();
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <CustomModal 
            open={open}
            close={close}
            fullWidth
            title={`Anulare mentenanță`}
            content ={
                <Grid container spacing={2}>
                    <TextField 
                        label={lang.OBSERVATION[language]}
                        value={note}
                        onChange={e => setNote(e.target.value)}
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
            }
            execute={() => cancel()}
            validate={true}
            language={language}
        />
    )
};

const mapStateToProps = (state) => ({
    geolocation: state.config.geolocation
})

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Cancel);
